<valg-dk-page-layout
  [election]="election"
  [links]="links"
  [filterLinks]="filterLinks"
  [sideNavTitleType]="sideNavTitleType"
  [parentLinkType]="parentLinkType">
  <valg-dk-breadcrumbs></valg-dk-breadcrumbs>
  <div class="d-flex justify-content-between">
  <h1 class="h2 mt-0 mb-8 hyphenate">{{ 'page.details_page.title' | translate: {area: nominationDistrictName} }}</h1>
  <button color="text-only" valgButton (click)="onDownloadReportClick()" class="hidden__sm">
    <mat-icon [svgIcon]="SvgIcon.Download"></mat-icon>{{ 'export_data.button_title' | translate }}
  </button>
  </div>
  <div class="row">
    <div class="col-12">
      <valg-card [border]="true" [custom]="true">
        <valg-dk-count-status [resultSummary]="resultSummary" title="count_status.title" [resultType]="resultType" [candidateDataLoadState]="candidateDataLoadState" [updated]="countStatusUpdated" [data]="countStatus"></valg-dk-count-status>
      </valg-card>
      <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="showPartiesTable && !showReferendumStatus">
        <valg-dk-expandable-party-list #expandablePartyList  [data]="parties"
         [candidateDataLoadState]="candidateDataLoadState" [resultSummary]="resultSummary"
         [resultType]="resultType"></valg-dk-expandable-party-list>
      </valg-card>

      <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="showReferendumStatus">
        <valg-dk-referendum-status [data]="referendumStatus" [election]="election"></valg-dk-referendum-status>
      </valg-card>
    </div>
    <div *ngIf="!showReferendumStatus" class="col-12 col-lg-6">
      <valg-card [border]="true" [custom]="true" class="p-0">
        <valg-table
          [columnDefinition]="statusPollingDistrictColumnDef"
          [data]="statusPollingDistrict"
          [itemName]="'status_polling_district.table.item_name' | translate"
          [title]="'status_polling_district.table.title' | translate"
          [hasPagination]="false"
          [displayItemCount]="false"
          [hasMainActionButton]="false">
          <h2 class="m-0 text--f20 text--500">{{ 'status_polling_district.table.title' | translate }}</h2>
        </valg-table>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6">
      <valg-card *ngIf="!showReferendumStatus" [border]="true" [custom]="true" class="p-0">
        <valg-dk-top-candidates [resultSummary]="resultSummary" [resultType]="resultType" [data]="topCandidates"></valg-dk-top-candidates>
      </valg-card>

      <valg-card [border]="true" [custom]="true">
        <valg-dk-voting-details [resultSummary]="resultSummary" [data]="votingDetails" [list]="votingDetailsList" [resultType]="resultType" [candidateDataLoadState]="candidateDataLoadState"></valg-dk-voting-details>
      </valg-card>
    </div>
  </div>

</valg-dk-page-layout>
